(function inbentaQuestion() {
  const isCompExists = GlobalSite.checkDependency('GlobalSite.isCompExists');
  const compName = 'inbenta-question';
  const logFactory = GlobalSite.checkDependency('GlobalSite.logFactory');
  const Log = logFactory(`${compName}.js`);

  if (!isCompExists(compName, Log)) {
    return;
  }

  const inbentaApi = GlobalSite.checkDependency('GlobalSite.inbentaApi');
  const productQuestionUi = GlobalSite.checkDependency('GlobalSite.productQuestionUi');

  $(async () => {
    const inbentaAuth = await inbentaApi.auth();
    const urlsProduct = inbentaAuth && (await inbentaApi.getUrlsProduct());
    const productContents = urlsProduct?.results[0]?.value?.urls
      .find((url) => url.url === window.location.pathname)
      ?.contents.replaceAll(';', ',');
    const urlsProductContents =
      inbentaAuth && (await inbentaApi.getUrlsProductContents(productContents));

    productQuestionUi($('.accordion-faq'), urlsProductContents?.results);
  });
})();
